package feature.productSubCategory.viewModel

import common.constants.Server
import feature.app.AppViewModel
import feature.auth.handler.AuthHandler
import feature.business.handler.BusinessHandler
import feature.productCategory.event.ProductCategoryEvent
import feature.productCategory.handler.ProductCategoryHandler
import feature.productSubCategory.handler.ProductSubCategoryHandler
import feature.productSubCategory.model.ProductSubCategory
import feature.productSubCategory.network.CreateProductSubCategoryRequest
import feature.productSubCategory.network.ProductSubCategoryNetwork
import feature.productSubCategory.network.RetrieveProductSubCategoryRequest
import feature.productSubCategory.network.UpdateProductSubCategoryRequest
import feature.productSubCategory.repository.ProductSubCategoryRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class ProductSubCategoryViewModel :
    AppViewModel() {
    private val repository: ProductSubCategoryRepository =
        ProductSubCategoryHandler.shared().repository
    val allSubCategory: StateFlow<List<ProductSubCategory>>
        get() = repository.allSubCategory
    val selectedSubCategory: StateFlow<ProductSubCategory?>
        get() = repository.selectedSubCategory

    val editSubCategory: StateFlow<ProductSubCategory?>
        get() = repository.editSubCategory

    fun setEditSubCategory(value: ProductSubCategory?) {
        repository.setEditSubCategory(value)
    }

    fun setSelectedSubCategory(value: ProductSubCategory?) {
        repository.setSelectedSubCategory(value)
    }

    fun loadSubCategory() {
        if (!BusinessHandler.shared().repository.business.value.Id.isNullOrEmpty()) {
//            CoroutineScope(Job() + Dispatchers.IO).launch {
//                val businessId = BusinessHandler.shared().repository.business.value.Id
//                productSubCategoryRepository.subCategoryLiveData.postValue(
//                    DatabaseHandler.shared().database.productSubCategoryDao()
//                        .getAllItemsForBusiness(businessId) as ArrayList<ProductSubCategory>?
//                )
//            }
        }
    }

    fun fetchAll() {
        val otpRoute = Server.getRestApiEndPointFor(ProductCategoryEvent.RETRIEVE)
        val request =
            RetrieveProductSubCategoryRequest(BusinessHandler.shared().repository.business.value.Id)
        startLoading()
        CoroutineScope(Job() + Dispatchers.Default).launch {
            ProductSubCategoryNetwork().retrieve(request) {
                stopLoading()
                if (it?.payload != null && it.payload.isNotEmpty()) {
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        repository.subCategoryLiveData.emit(it.payload)
                    }
                }
            }
        }
    }

    fun createNewSubCategory(name: String, completion: () -> Unit) {
        if (ProductCategoryHandler.shared().repository.selectedCategory.value?.Id?.isNotEmpty() == true) {
            val request = CreateProductSubCategoryRequest(
                name,
                ProductCategoryHandler.shared().repository.selectedCategory.value!!.Id,
                BusinessHandler.shared().repository.business.value.Id,
                AuthHandler.shared().repository.authUser.value.id
            )
            startLoading()
            CoroutineScope(Job() + Dispatchers.Default).launch {
                ProductSubCategoryNetwork().create(request) {
                    stopLoading()
                    if (it?.payload != null && it.payload.Id.isNotEmpty()) {
                        CoroutineScope(Job() + Dispatchers.Default).launch {
                            val allCategory: MutableList<ProductSubCategory> =
                                repository.allSubCategory.value.toMutableList()
                            allCategory.add(it.payload)
                            repository.subCategoryLiveData.emit(allCategory)
                            completion()
                        }
                    } else {
                        completion()
                    }
                }
            }
        }

    }

    fun update(name: String, id: String, completion: () -> Unit) {
        val request = UpdateProductSubCategoryRequest(
            name,
            id,
            BusinessHandler.shared().repository.business.value.Id,
            AuthHandler.shared().repository.authUser.value.id
        )
        startLoading()
        CoroutineScope(Job() + Dispatchers.Default).launch {
            ProductSubCategoryNetwork().update(request) {
                stopLoading()
                if (it?.payload != null && it.payload.Id.isNotEmpty()) {
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        val allCategory: MutableList<ProductSubCategory> =
                            repository.allSubCategory.value.toMutableList()
                        allCategory.add(it.payload)
                        repository.subCategoryLiveData.emit(allCategory)
                    }
                }
                completion()
            }
        }
    }
}